import type { FrontendWidget } from '../types';
import { AdjustableContactFormWidgetComponent } from './AdjustableContactFormWidgetComponent';
import type {
  AdjustableContactFormConfig,
  AdjustableContactFormResolved,
} from './types';

export const adjustableContactFormWidget: FrontendWidget<
  AdjustableContactFormConfig,
  AdjustableContactFormResolved
> = {
  componentType: 'widgets.adjustable-contact-form',
  displayName: 'Adjustable Contact Form',
  ComponentA: AdjustableContactFormWidgetComponent,
  resolveSync: (config) => config,
};
